import AnimatedNumber from '@components/Animation/AnimatedNumber';
import StudentThumbnail from '@components/StudentThumbnail';
import {
    CardImage,
    CardInfo,
    CardInfoLastname,
    CardInfoName,
    CardInfoPercentage,
    CardItem,
    ColorOverlay
} from './SwipeCard.styled';
import Missing from '@assets/svg/match/missing.svg';
import Late from '@assets/svg/match/late.svg';
import Attending from '@assets/svg/match/attending.svg';
import persistentStore from '@store/persistentStore';
import {AttendanceMap} from '@models/AttendanceType';
import {studentGridThemeColors, studentThemeContrastColors, SwipeThemeColors} from '@styles/themes';
import { useI18n } from '@i18n/useI18n';
import HaveNote from '@components/Buttons/HaveNote';
import RegMethod from "@components/Buttons/RegistrationMethod";
import {ViewColoring} from "@models/Accessibility";
import {useStore} from "@store/appStore";
import { calculatePercentage, ShowabsenceOrAttendance } from '@utils/percentageTools';
import StatusBar from '@components/Buttons/StatusBar';

interface IProps {
  student?:any,
}
  
export const SwipeCard = (props: IProps) => {
    const { privacyEnabled, viewColoring, viewIndicators } = persistentStore();
    const {systemSettings, schedule, scheduleIndex} = useStore()
    const {settings } = useStore();
    const i18n = useI18n();
    let defaultAttendanceSetting = systemSettings.find(s => s.APP_Setting_ID === 19)
    const attendanceStatus = AttendanceMap[props.student.type] || 'default';
    const status = defaultAttendanceSetting && defaultAttendanceSetting.value === "Present" && props.student.type === -1?AttendanceMap[1]:attendanceStatus
    const coloring = SwipeThemeColors[status] ;

  return (
    <CardItem>
      <ColorOverlay>
        <Missing />
        <Late />
        <Attending />
      </ColorOverlay>
      <CardImage>
        <StatusBar swipe={true} note={{swipeView:true, id: props.student.sis_id, show:props.student.notePresent, notecount:props.student.noteUnreadCount}}>
          <RegMethod studentUsername={props.student.username} studentId={props.student.sis_id} reservationId={schedule?.data[scheduleIndex]?.id} swipeView={true} show={props.student.initial_Method !== null && props.student.initial_Method !== 0} registrationMethod={props.student.initial_Method} />
        </StatusBar>
        <StudentThumbnail regView={true} top={"-10%"} font={"16vh"} name={props.student.firstname + " " + props.student.lastname} highRes={true} src={props.student.username} />
      </CardImage>
      <CardInfo privacyEnabled={privacyEnabled} coloring={coloring}>
        <div>
          <CardInfoName>{props.student.firstname}</CardInfoName>
          <CardInfoLastname>{props.student.lastname}</CardInfoLastname>
        </div>
        <div>
          <CardInfoPercentage>{i18n.t("course")}: <span><AnimatedNumber value={ShowabsenceOrAttendance(settings.SHOWPRESENCE, props.student.merit?calculatePercentage(props.student.course_duration, props.student.course_absence_duration):props.student.course_percentage)}>%</AnimatedNumber></span></CardInfoPercentage>
          <CardInfoPercentage>{i18n.t("total")}: <span><AnimatedNumber value={ShowabsenceOrAttendance(settings.SHOWPRESENCE, props.student.merit?calculatePercentage(props.student.total_duration, props.student.total_absence_duration):props.student.total_percentage)}>%</AnimatedNumber></span></CardInfoPercentage>
        </div>
      </CardInfo>
    </CardItem>
  );
};

export default SwipeCard;